import React from 'react';
import { cn } from '../../utils/cn';

const variants = {
  primary:
    'bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm hover:shadow-md border border-transparent',
  secondary:
    'bg-white text-slate-800 border border-slate-200 hover:bg-slate-50 hover:border-slate-300',
  ghost: 'bg-transparent text-slate-700 hover:bg-slate-100 border border-transparent',
  danger: 'bg-rose-600 text-white hover:bg-rose-700 border border-transparent',
  outlineIndigo:
    'bg-transparent text-indigo-700 border border-indigo-200 hover:bg-indigo-50 hover:border-indigo-300',
  purple:
    'bg-violet-600 text-white hover:bg-violet-700 shadow-sm hover:shadow-md border border-transparent',
  outlinePurple:
    'bg-white text-violet-700 border border-violet-200 hover:bg-violet-50 hover:border-violet-300',
};

const sizes = {
  sm: 'px-3 py-2 text-xs sm:text-sm min-h-[40px]',
  md: 'px-4 py-2.5 text-sm min-h-[44px]',
  lg: 'px-6 py-3.5 text-sm sm:text-base font-bold min-h-[48px]',
};

/**
 * Accessible button with consistent focus ring; all behavior controlled by caller.
 */
export const AppButton = React.forwardRef(function AppButton(
  {
    className,
    variant = 'primary',
    size = 'md',
    type = 'button',
    disabled,
    fullWidth,
    children,
    ...rest
  },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-xl font-bold transition-all duration-200',
        fullWidth && 'w-full sm:w-auto',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2',
        'disabled:pointer-events-none disabled:opacity-50',
        'touch-manipulation',
        variants[variant] ?? variants.primary,
        sizes[size] ?? sizes.md,
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
});
